import { defineMessages } from 'react-intl';

const messages = defineMessages({
  visiting: {
    id: 'hubs.repvisits.title',
    defaultMessage: '{collegeName} is visiting your school',
  },
  event: {
    id: 'hubs.repvisits.eventname',
    defaultMessage: '{rep} from {collegeName}',
  },
  signup: {
    id: 'hubs.repvisits.signup',
    defaultMessage: 'REGISTER',
  },
  cancel: {
    id: 'hubs.repvisits.cancel',
    defaultMessage: 'CANCEL',
  },
  moredetails: {
    id: 'hubs.repvisits.details.more',
    defaultMessage: 'View more details',
  },
  lessdetails: {
    id: 'hubs.repvisits.details.less',
    defaultMessage: 'View fewer details',
  },
  nodetails: {
    id: 'hubs.repvisits.details.none',
    defaultMessage: 'No additional details available',
  },
  deadlinepassed: {
    id: 'hubs.repvisits.deadlinepassed',
    defaultMessage: 'Registration closed',
  },
});

export default messages;
